// from - https://pixijs.io/examples/#/textures/gradient-resource.js
export default class RainbowGradientResource extends PIXI.resources.Resource {
    constructor() {
        // pass width and height. (0,0) if we dont know yet
        // gradient needs only 1 pixel height
        super(256, 1);
    }

    upload(renderer, baseTexture, glTexture) {
        const {width} = this; // default size or from baseTexture?
        const {height} = this; // your choice.

        // temporary canvas, we dont need it after texture is uploaded to GPU
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');

        //  const grd = ctx.createLinearGradient(0, 0, width, height);
        const grd = ctx.createLinearGradient(0, 0, width, 0);
        //   grd.addColorStop(0, 'rgba(255, 255, 255, 0.0)');
        //  grd.addColorStop(0.3, 'cyan');
        //   grd.addColorStop(0.7, 'red');
        //   grd.addColorStop(1, 'green');

        //grd.addColorStop(0, 'white');
        //grd.addColorStop(1, 'black');

        grd.addColorStop(0, 'red');
        grd.addColorStop(0.2, 'blue');
        grd.addColorStop(0.4, 'green');
        grd.addColorStop(0.6, 'yellow');
        grd.addColorStop(0.8, 'orange');
        grd.addColorStop(1, 'red');

        ctx.fillStyle = grd;
        ctx.fillRect(0, 0, width, height);

        // This info ios useful if upload happens second time
        // Some people use that to track used memory
        glTexture.width = width;
        glTexture.height = height;

        // PURE WEBGL CALLS - that's what its all about.
        // PixiJS cant wrap all that API, we give you access to it!
        const {gl} = renderer;
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, baseTexture.premultiplyAlpha);
        gl.texImage2D(baseTexture.target, 0, baseTexture.format, baseTexture.format, baseTexture.type, canvas);

        return true;
    }
}
